export default __webpack_public_path__ + "static/media/male_female.6e259bf9.png";